export default __webpack_public_path__ + "static/media/onpremise-version.49d5adae.svg";